import type { FileType, ImageType } from "@/types/baseTypes";
import { hasCopyrightContent } from "../Copyright/copyrightUtils";

export interface MediaInfoFlags {
  hasVideoDescription: boolean;
  hasMobileDescription: boolean;
  hasTabletDescription: boolean;
  hasDesktopDescription: boolean;
  hasFullhdDescription: boolean;
  hasVideoCopyright: boolean;
  hasImageCopyright: boolean;
}

export interface MediaInfoFlagInput {
  video?: FileType;
  image_desktop?: ImageType | false;
  image_fullhd?: ImageType | false;
  image_tablet?: ImageType | false;
  image_mobile?: ImageType | false;
  copyright?: string;
  ignoreImageMetadata?: boolean;
}

export const computeMediaInfoFlags = ({
  video,
  image_desktop,
  image_fullhd,
  image_tablet,
  image_mobile,
  copyright,
  ignoreImageMetadata = false,
}: MediaInfoFlagInput): MediaInfoFlags => ({
  hasVideoDescription: !!video?.description,
  hasMobileDescription:
    !ignoreImageMetadata && !!(image_mobile && image_mobile.description),
  hasTabletDescription:
    !ignoreImageMetadata && !!(image_tablet && image_tablet.description),
  hasDesktopDescription:
    !ignoreImageMetadata && !!(image_desktop && image_desktop.description),
  hasFullhdDescription:
    !ignoreImageMetadata && !!(image_fullhd && image_fullhd.description),
  hasVideoCopyright: !!copyright,
  hasImageCopyright:
    !ignoreImageMetadata && hasCopyrightContent(image_desktop || undefined),
});
